module.exports = __webpack_public_path__ + "img/bg_lianxiwomen.6d5f1b77.png";